import { patch } from '@rails/request.js'
import Sortable from 'sortablejs'

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    group: String,
    scopeName: String,
    relativePosition: { type: String, default: 'before' }
  }

  static get shouldLoad(){
    return JSON.parse(document.body.dataset.editable)
  }

  initialize() {
    const controller = this

    Sortable.create(this.element, {
      animation: 150,
      handle: '.handle',
      draggable: '.is-draggable',
      group: {
        name: this.groupValue,
        revertClone: false
      },
      onEnd({item, to}) {
        let sortableId = null

        if (controller.relativePositionValue === 'before' && item.nextElementSibling) {
          sortableId = item.nextElementSibling.dataset.sortableId
        } else if (controller.relativePositionValue === 'after' && item.previousElementSibling) {
          sortableId = item.previousElementSibling.dataset.sortableId
        }

        const params = {
          position: {
            [controller.relativePositionValue]: sortableId
          }
        }

        if (controller.hasScopeNameValue) {
          params[controller.scopeNameValue] = to.dataset.sortableScopeId || null
        }

        patch(item.dataset.sortableUpdateUrl, {
          body: params,
          responseKind: 'turbo-stream'
        })
      }
    })
  }
}
